import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { getStatus } from 'helpers/status-badge';
import Avatar from 'components/base/Avatar';
import StatusBadge from 'components/custom/ui/StatusBadge';
// import { Icon } from '@iconify/react';
import { formatDate } from 'services/utils';
import { hrmsPaths } from 'constants/pagePath';

// Dummy data for separated employees
export const SeparatedEmployeeColumns = [
  {
    accessorKey: 'first_name',
    id: 'first_name',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <FeatherIcon
              icon="user"
              size={16}
              className="text-primary-600 dark__text-primary-300"
            />
          </div>
          <span>Name</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const {
        employee_id,
        employee_image,
        first_name,
        last_name,
        employee_mobile,
        employee_unique_id
      } = original;
      return (
        <div className="d-flex align-items-center">
          <Link to={`${hrmsPaths.employee.detail(employee_id)}`}>
            <Avatar src={employee_image} size="xl" className="me-3" />
          </Link>
          <div>
            <Link
              to={`${hrmsPaths.employee.detail(employee_id)}`}
              className="fs-8 fw-bold"
            >
              {first_name} {last_name}
            </Link>
            <div className="d-flex align-items-center">
              <Link to={''} className="mb-0 text-1000 fw-semi-bold fs-9 me-2">
                {employee_unique_id}
              </Link>
            </div>
            <Link className="text-700" to={`tel:${employee_mobile}`}>
              {employee_mobile || '--'}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '20%' }, className: 'ps-0 border-end' },
      cellProps: { className: 'white-space-nowrap ps-0 border-end' }
    }
  },
  //   {
  //     accessorKey: 'date_of_birth',
  //     header: 'Date of Birth',
  //     cell: ({ row: { original } }) => {
  //       const { date_of_birth } = original;
  //       return (
  //         <div>
  //           <p className="mb-0 fs-9">
  //             {formatDate(date_of_birth, 'DD MMM YYYY')}
  //           </p>
  //         </div>
  //       );
  //     },
  //     meta: {
  //       headerProps: { className: 'text-start' },
  //       cellProps: {
  //         className: 'text-700 ps-2 text-start white-space-nowrap'
  //       }
  //     }
  //   },
  {
    accessorKey: 'department_name',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <FeatherIcon
              icon="users"
              size={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Department</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { department_name } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <div className="fw-normal">{department_name || '--'}</div>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '15%' }, className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0 ' }
    }
  },
  {
    accessorKey: 'designation_name',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <FeatherIcon
              icon="users"
              size={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Designation</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { designation_name } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <div className="fw-normal">{designation_name || '--'}</div>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '15%' }, className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0 ' }
    }
  },
  {
    accessorKey: 'joining_date',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-100 rounded me-2">
            <FeatherIcon
              icon="calendar"
              size={16}
              className="text-success-600 dark__text-success-300"
            />
          </div>
          <span>Joining Date</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { joining_date } = original;
      return (
        <div>
          <p className="mb-0 fs-9">{formatDate(joining_date, 'DD MMM YYYY')}</p>
        </div>
      );
    },
    meta: {
      headerProps: { className: 'text-start' },
      cellProps: {
        className: 'text-700 ps-2 text-start white-space-nowrap'
      }
    }
  },
  {
    accessorKey: 'separation_date',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-danger-100 rounded me-2">
            <FeatherIcon
              icon="calendar"
              size={16}
              className="text-danger-600 dark__text-danger-300"
            />
          </div>
          <span>Separation Date</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { separation_date } = original;
      return (
        <div>
          <p className="mb-0 fs-9">
            {formatDate(separation_date, 'DD MMM YYYY')}
          </p>
        </div>
      );
    },
    meta: {
      headerProps: { className: 'text-start' },
      cellProps: {
        className: 'text-700 ps-2 text-start white-space-nowrap'
      }
    }
  },
  {
    accessorKey: 'duration',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-warning-100 rounded me-2">
            <FeatherIcon
              icon="clock"
              size={16}
              className="text-warning-600 dark__text-warning-300"
            />
          </div>
          <span>Duration</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { duration } = original;
      return (
        <div>
          <p className="mb-0 fs-9">{duration}</p>
        </div>
      );
    },
    meta: {
      headerProps: { className: 'text-start' },
      cellProps: {
        className: 'text-700 ps-2 text-start white-space-nowrap'
      }
    }
  },
  {
    accessorKey: 'separation_reason',
    header: 'Reason',
    cell: ({ row: { original } }) => {
      const { separation_reason } = original;
      return (
        <div>
          <StatusBadge
            status={separation_reason}
            getStatus={() => ({
              variant: 'info',
              icon: 'info-circle'
            })}
          />
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '15%' } },
      cellProps: { className: 'white-space-nowrap' }
    }
  },
  {
    accessorKey: 'employee_status',
    header: 'Status',
    cell: ({ row: { original } }) => (
      <>
        <StatusBadge
          status={original.status}
          lastComment={original.separation_reason}
          getStatus={getStatus}
        />
      </>
    ),
    meta: {
      headerProps: {
        style: { width: '10%' }
      }
    }
  }
];

export default SeparatedEmployeeColumns;
